module.exports = __webpack_public_path__ + "static/img/qItem2-img2.ac6542e.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/qItem2-img2.png
// module id = EGn1
// module chunks = 1